export const GET_PRE_PAYROLL = 'GET_PRE_PAYROLL';
export const CHANGE_PRE_PAYROLL_STATUS = 'CHANGE_PRE_PAYROLL_STATUS';
export const CLEAR_PRE_PAYROLL = 'CLEAR_PRE_PAYROLL';

const INITIAL_STATE = {
  prePayrollSelected: null,
  prePayrollsObj: {}
}

export const prePayrollsReducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case GET_PRE_PAYROLL:
      return {
        ...state,
        prePayrollsObj: action.payload,
      }
    
    case CHANGE_PRE_PAYROLL_STATUS:
      return {
        ...state,
        prePayrollsObj: {...state.prePayrollsObj, status: action.payload},
      }

    case CLEAR_PRE_PAYROLL:
      return {
          ...state,
          ...INITIAL_STATE,
      };

    default :
      return state
  }
}